import React from 'react';
import './Policies.css';

const LegalCompliance: React.FC = () => {
    return (
        <div className="terms-container">
            <section className="legal-section">
                <h2 className="section-title">1. Legal Compliance</h2>
                <div className="content-block">
                    <p className="mt-2">
                        DateNow complies with all applicable laws and regulations, including:
                    </p>
                    <ul className="list">
                        <li>GDPR (General Data Protection Regulation) for European users.</li>
                        <li>CCPA (California Consumer Privacy Act) for users in California, USA.</li>
                        <li>Google Play and Apple App Store policies regarding data privacy and security.</li>
                    </ul>
                    <p className="mt-2">
                        Users may request access to or deletion of their personal data by contacting us at{' '}
                        <a href="mailto:paulfortuneltd@gmail.com" className="email">paulfortuneltd@gmail.com</a>.
                    </p>
                </div>
            </section>

            {/* Updates to These Policies Section */}
            <section className="updates-section">
                <h2 className="section-title">Updates to These Policies</h2>

                <div className="content-block">
                    <p className="mt-2">We reserve the right to update these policies at any time.</p>
                    <ul className="list">
                        <li>Significant changes will be communicated to users via the app and/or email.</li>
                        <li>Continued use of DateNow after changes constitutes acceptance of the new policies.</li>
                    </ul>
                </div>
            </section>

            {/* Contact Section */}
            <section className="contact-section">
                <h2 className="section-title">Contact Us</h2>
                <div className="content-block">
                    <p className="mt-2">For any questions, concerns, or feedback, please contact us at:</p>
                    <p className="mt-2">
                        📧 Email: <a href="mailto:paulfortuneltd@gmail.com" className="email">paulfortuneltd@gmail.com</a>
                    </p>
                </div>
            </section>
        </div>
    );
};

export default LegalCompliance;